import { type ProviderOffer } from "../../../../../types/dtos/api/sales/provider-offer.dto";

/**
 * Returns the user-facing provider label for segment offer display.
 */
export const providerLabelFor = ( provider: ProviderOffer["provider"] ): string => {
    switch ( provider ) {
        case "swiss_cff":
            return "SBB CFF FFS";

        case "blablacar":
            return "BlaBlaCar";

        case "blabladaily":
            return "BlaBlaDaily";

        case "rental_motis":
            return "Rental";

        case "completion_strategy":
            return "Completion";

        default:
            return "Unknown";
    }
};
